import React from 'react';
import EmojiImage from '../../EmojiImage';
import './EmojiPopupContentNoResults.scss';
import { useTranslator } from "../../../i18n/useTranslator";

const EmojiPopupContentNoResults = ({ style, gridSize }: { style?: React.CSSProperties; gridSize: number }) => {
    const translate = useTranslator('popup', 'emoji');

    return (
        <div style={style} className="EmojiPopupContentNoResults">
            {translate('noResults')} <EmojiImage emojiCode="1F614" size={gridSize * 2.4} />
        </div>
    );
};

export default EmojiPopupContentNoResults;
